export default "__VITE_ASSET__BuT1Oemr__"